// extracted by mini-css-extract-plugin
export default {"scheduleSwither":"ScheduleSelect_scheduleSwither__j7PxA","scheduleSwither__input":"ScheduleSelect_scheduleSwither__input__ekom3"};